import React from 'react'
import { ArrowRight } from 'react-feather'

import higaLogo from '../../assets/images/logo-higa-header.png'
import ButtonPrimary from '../../shared/components/ButtonPrimary'
import EnvironmentBadge from '../../shared/components/EnvironmentBadge'
import InputLabeled from '../../shared/components/InputLabeled'
import Loading from '../../shared/components/Loading'
import { formatCPF } from '../../shared/util/mask'
import { LoginWrapper } from './styles'
import { IViewProps } from './types'

function Login(props: IViewProps): JSX.Element {
	const {
		handleSubmit,
		handleChange,
		userLogin,
		rememberMe,
		handleToggleRemember,
		isFormValid,
		isLoading,
	} = props

	return (
		<LoginWrapper>
			<main className='login-content'>
				<img src={higaLogo} alt='Logo do Higa Atacado' className='logo' />

				<header className='login-header'>
					<p className='kicker'>{'Painel administrativo'}</p>
					<h1 className='title'>{'Bem vindo de volta!'}</h1>
				</header>

				<section className='login-card'>
					<form onSubmit={handleSubmit}>
						<InputLabeled
							label='Matrícula'
							id='enrollment'
							name='enrollment'
							className='input'
							placeholder='00000'
							inputMode='numeric'
							onChange={handleChange}
							value={userLogin.enrollment}
							maxLength={5}
						/>
						<InputLabeled
							label='CPF'
							id='documentNumber'
							name='documentNumber'
							className='input'
							placeholder='000.000.000-00'
							inputMode='numeric'
							onChange={handleChange}
							value={formatCPF(userLogin.documentNumber)}
							maxLength={14}
						/>

						<label className='remember' htmlFor='rememberMe'>
							<input
								type='checkbox'
								id='rememberMe'
								checked={rememberMe}
								onChange={handleToggleRemember}
							/>
							<span>{'Lembre-se de mim'}</span>
						</label>

						<ButtonPrimary
							type='submit'
							className='button'
							disabled={!isFormValid || isLoading}
						>
							{isLoading ? (
								<Loading color='#FFFFFF' />
							) : (
								<>
									{'Entrar'}
									<ArrowRight size={18} />
								</>
							)}
						</ButtonPrimary>
					</form>
				</section>

				<EnvironmentBadge withPrefix className='environment' />
			</main>
		</LoginWrapper>
	)
}

export default Login
